var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 15,
    stroke: "#9C9C9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7152 4.1591L15.8115 7.61591C16.0628 7.82804 16.0628 8.17196 15.8115 8.38409L11.7152 11.8409C11.4638 12.053 11.0563 12.053 10.8049 11.8409C10.5535 11.6288 10.5535 11.2848 10.8049 11.0727L13.8024 8.54319L6.64374 8.54319C6.28825 8.54319 6.00007 8.29999 6.00007 8C6.00007 7.70001 6.28825 7.45681 6.64374 7.45681L13.8024 7.45681L10.8049 4.92728C10.5535 4.71515 10.5535 4.37122 10.8049 4.1591C11.0563 3.94697 11.4638 3.94697 11.7152 4.1591Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideJoin);
export default __webpack_public_path__ + "static/media/side-join.3b3bc355399d774abe113c26b020d48d.svg";
export { ForwardRef as ReactComponent };